export default __webpack_public_path__ + "static/Roobert-Medium-78ecb7d44e31c5d1d1456b1be6f1bb83.ttf";